module.exports = __webpack_public_path__ + "img/firewall.e945efeb.svg";